import React from 'react'
import '../assets/styles/HomePage.css'
import affiche  from '../assets/images/Capture1.PNG'
import { Link } from 'react-router-dom'
import { useState } from 'react'
import axios from 'axios'
function HomePage() {

  //isTrue à true pour éviter de rettaper le mot secret
  const [isTrue, setIsTrue] = useState(true)
  const [essai, setEssai] = useState("")
  const [isWrong, setIsWrong] = useState(false)
  const magicWord = "fantastic"

  const postData = () => {
    axios.post('https://63c9b718904f040a966397d6.mockapi.io/response', {
    essai,
  })
  if(essai.toLowerCase() === magicWord){
    setIsTrue(!isTrue)
    setIsWrong(false)
  }else {
    setIsWrong(true)
  }
};
      
  return (
    <div className="homepageContainer">
    <img src= {affiche} alt='affiche FIFF 2023'></img>
    {isWrong ? <div className="mauvaisCode">Mauvais code...</div> : null}
    {isTrue ? <Link to='/Accueil'><h1>Entrez</h1></Link> 
    : 
    <input 
    valeur=""
    onChange={(e) => setEssai(e.target.value)}
    onClick={(e) => setIsWrong(false)}
    className="codeSecret" 
    type="password" 
    placeholder="Entrez le code" />
    }
    {!isTrue ? <button className="enterButton" type='submit' onClick={() => postData()}>Envoyer</button> : null}
    
    </div>
  );
}

export default HomePage